(() => {
  const money = (value) => `PKR ${new Intl.NumberFormat('en-PK', { maximumFractionDigits: 0 }).format(value)}`;
  const roundUp = (value, increment) => Math.ceil((value - 0.000001) / increment) * increment;
  const roundDown = (value, increment) => Math.floor((value + 0.000001) / increment) * increment;
  const formatMetres = (value) => Number(value.toFixed(2)).toString();
  const isStandardCut = (metres, standardMetres) => Math.abs(metres - standardMetres) < 0.000001;

  const update = (studio) => {
    const k = studio.querySelector('[data-look-kameez]');
    const w = studio.querySelector('[data-look-waistcoat]');
    const summary = studio.querySelector('[data-look-summary]');
    const prices = studio.querySelector('[data-look-prices]');
    const enquiry = studio.querySelector('[data-look-enquire]');
    const error = studio.querySelector('[data-look-error]');
    const lengths = studio.querySelector('[data-look-lengths]');
    const kLength = studio.querySelector('[data-look-kameez-length]');
    const wLength = studio.querySelector('[data-look-waistcoat-length]');
    const pieces = studio.querySelector('[data-look-pieces]:checked')?.value || 'both';
    const custom = studio.querySelector('[data-look-cut]:checked')?.value === 'custom';
    if (!k || !w || !summary || !prices || !enquiry || !error || !lengths || !kLength || !wLength || !k.selectedOptions.length || !w.selectedOptions.length) return;

    const needK = pieces !== 'waistcoat';
    const needW = pieces !== 'suit';
    const kOption = k.selectedOptions[0];
    const wOption = w.selectedOptions[0];
    k.disabled = !needK;
    w.disabled = !needW;
    k.closest('.sf-look-studio__field').hidden = !needK;
    w.closest('.sf-look-studio__field').hidden = !needW;
    lengths.hidden = !custom;
    kLength.disabled = !custom || !needK;
    wLength.disabled = !custom || !needW;
    kLength.closest('.sf-look-studio__field').hidden = !needK;
    wLength.closest('.sf-look-studio__field').hidden = !needW;
    studio.classList.toggle('sf-look-studio--suit-only', !needW);

    const kColour = kOption.dataset.colour;
    const wColour = wOption.dataset.colour;
    studio.style.setProperty('--sf-look-kameez', needK ? kColour : '#d3c4af');
    studio.style.setProperty('--sf-look-waistcoat', wColour);
    const kSwatch = studio.querySelector('[data-look-kameez-swatch]');
    const wSwatch = studio.querySelector('[data-look-waistcoat-swatch]');
    kSwatch.style.backgroundColor = kColour;
    wSwatch.style.backgroundColor = wColour;
    kSwatch.hidden = !needK;
    wSwatch.hidden = !needW;

    const kMetres = custom ? Number(kLength.value) : 4.25;
    const wMetres = custom ? Number(wLength.value) : 1.25;
    const kRate = Number(kOption.dataset.rate);
    const wRate = Number(wOption.dataset.rate);
    const kIncrement = Number(studio.dataset.suitRounding);
    const wIncrement = Number(studio.dataset.waistcoatRounding);
    const validLength = (input, metres) => /^\d+(?:\.\d{1,2})?$/.test(input.value) && Number.isFinite(metres) && metres >= 0.01 && metres <= 100;
    const valid = (!needK || (!custom || validLength(kLength, kMetres))) && (!needW || (!custom || validLength(wLength, wMetres))) &&
      Number.isFinite(kRate) && kRate > 0 && Number.isFinite(wRate) && wRate > 0 &&
      Number.isInteger(kIncrement) && kIncrement > 0 && Number.isInteger(wIncrement) && wIncrement > 0;
    error.hidden = valid;
    error.textContent = valid ? '' : 'Enter a length between 0.01 m and 100 m, to two decimal places, for each selected piece.';
    enquiry.hidden = !valid;
    prices.replaceChildren();
    if (!valid) {
      summary.textContent = 'Please check your custom lengths.';
      return;
    }

    const kStandard = isStandardCut(kMetres, 4.25);
    const wStandard = isStandardCut(wMetres, 1.25);
    const kPrice = needK ? (kStandard ? roundDown : roundUp)(kMetres * kRate, kIncrement) : 0;
    const wPrice = needW ? (wStandard ? roundDown : roundUp)(wMetres * wRate, wIncrement) : 0;
    const parts = [];
    if (needK) parts.push(`${kOption.value} shalwar kameez (${formatMetres(kMetres)} m)`);
    if (needW) parts.push(`${wOption.value} waistcoat (${formatMetres(wMetres)} m)`);
    summary.textContent = parts.join(' + ');
    const addPrice = (label, metres, rate, increment, price, standard) => {
      const row = document.createElement('p');
      row.textContent = `${label}: ${formatMetres(metres)} m × ${money(rate)}/m → ${money(price)} (${standard ? 'standard cut rounded down' : 'custom cut rounded up'} to ${money(increment)})`;
      prices.appendChild(row);
    };
    if (needK) addPrice('Shalwar kameez fabric', kMetres, kRate, kIncrement, kPrice, kStandard);
    if (needW) addPrice('Waistcoat fabric', wMetres, wRate, wIncrement, wPrice, wStandard);
    if (needK && needW) {
      const total = document.createElement('strong');
      total.textContent = `Three-piece fabric total: ${money(kPrice + wPrice)}`;
      prices.appendChild(total);
    }
    const url = new URL(enquiry.dataset.baseHref);
    const lines = [
      'Hello Sara Fabrics, I would like to request unstitched fabric for:',
      needK ? `Shalwar kameez: ${kOption.value}, ${formatMetres(kMetres)} m, ${money(kPrice)}` : null,
      needW ? `Waistcoat: ${wOption.value}, ${formatMetres(wMetres)} m, ${money(wPrice)}` : null,
      needK && needW ? `Fabric total: ${money(kPrice + wPrice)}` : null,
      `Cut: ${custom ? 'custom length' : 'standard length'}. Please confirm stock, exact shade, cutting and final order details.`
    ].filter(Boolean);
    url.searchParams.set('text', lines.join('\n'));
    enquiry.href = url.toString();
  };

  const init = () => {
    document.querySelectorAll('[data-sara-look-studio]').forEach((studio) => {
      if (studio.dataset.lookReady) return;
      studio.dataset.lookReady = 'true';
      studio.querySelectorAll('select, input').forEach((input) => {
        input.addEventListener('change', () => update(studio));
        if (input.type === 'number') input.addEventListener('input', () => update(studio));
      });
      update(studio);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
